import React from 'react';
import {UserComponent} from "react/UserComponent.jsx";

class ChatNotificationHostCodeComponent extends React.PureComponent{
	constructor(props){
		super(props);
		this.state = {
			copiedToClipboard: false,
			isFloating: props.isFloating
		};

		this.hostCodeClick = this.hostCodeMessageActivate.bind(this);
	}

	hostCodeMessageActivate(){
		const notification = this.props.chatMessage;
		const hostCode = notification.hostCode;

		if(this.state.copiedToClipboard)
		{
			return;
		}

		this.setState({
			copiedToClipboard: true
		});
		if(this.props.isFloating)
		{
			setTimeout(()=>{
				notification.removeFromChat();
			},4000);
		}
		else
		{
			setTimeout(()=>{
				this.setState({
					copiedToClipboard: false
				})
			},4000);
		}
		// The card says "Copied to Clipboard" itself.
		copyToClipboard(hostCode.code, () => {});
	}


	render(){
		const notification = this.props.chatMessage;
		const hostCode = notification.hostCode;

		const extraClasses = [];
		if(this.state.isFloating)
		{
			extraClasses.push('following');
		}
		if(this.state.copiedToClipboard)
		{
			extraClasses.push('copied');
		}

		return (
			<span
				style={{top: this.props.top, left: this.props.left}}
				ref={this.props.hostCodeRef}
				onClick={this.hostCodeClick} className={'chat_notification host_code_notification ' + extraClasses.join(' ')}>
				{!this.state.copiedToClipboard &&
				<React.Fragment>
					<UserComponent user={notification.player} unclickable={true} />
					<span>&nbsp;is hosting @</span>
					<span className="inline_host_code">&nbsp;{hostCode.displayValue()}</span>
				</React.Fragment>
				}
				{this.state.copiedToClipboard &&
				<span className="copied_to_clipboard">Copied to Clipboard</span>
				}
			</span>
		);
	}
}

export {ChatNotificationHostCodeComponent};